// API Configuration
export const API_CONFIG = {
  SIGNALR_HUB_URL: "https://chat.aizimba.cloud/chathub",
};
